import type { FunctionComponent } from 'react';

import { defineSlotComponent, findFirstForSlot } from '../../layouts/slots';

import styles from './PreviewFiltersLayout.module.less';

type PreviewFiltersLayoutType = FunctionComponent & {
  Preview: FunctionComponent;
  Filters: FunctionComponent;
};

/**
 * Layout component for the "step 2" section of the Reports flow.
 * Is essentially a two-column fluid layout, with the Preview content on the left,
 * and the filters/actions sidebar on the right.
 *
 * @example
 * <PreviewFiltersLayout>
 *   <PreviewFiltersLayout.Preview>
 *     <Preview />
 *   </PreviewFiltersLayout.Preview>
 *   <PreviewFiltersLayout.Filters>
 *     <Filters />
 *   </PreviewFiltersLayout.Filters>
 * </PreviewFiltersLayout>
 */
const PreviewFiltersLayout: PreviewFiltersLayoutType = ({ children }) => {
  const Preview = findFirstForSlot('Preview', children);
  const Filters = findFirstForSlot('Filters', children);
  return (
    <div className={styles.layout}>
      {Preview}
      {Filters}
    </div>
  );
};

/**
 * Slot for the preview content.
 */
PreviewFiltersLayout.Preview = defineSlotComponent('Preview', ({ children }) => (
  <main className={styles.preview}>
    {children}
  </main>
));

/**
 * Slot for the filters/actions sidebar.
 */
PreviewFiltersLayout.Filters = defineSlotComponent('Filters', ({ children }) => (
  <aside className={styles.filters}>
    {children}
  </aside>
));

export default PreviewFiltersLayout;
